module.exports = __webpack_public_path__ + "img/collection-engagementRings100Carat@2x.41b0e19.webp";